<p-multiSelect
  [options]="auditors"
  [group]="true"
  [(ngModel)]="_selected"
  (onChange)="onSelectedChange($event.value)"
  [maxSelectedLabels]="2"
  [disabled]="disabled"
  [showToggleAll]="false"
  [styleClass]="'w-full ' + styleClass"
  [class]="class"
  [appendTo]="appendTo"
  dataKey="name"
  selectedItemsLabel="Выбрано: {0}"
  optionLabel="name"
  filterBy="name"
  emptyFilterMessage="Нет результатов"
  emptyMessage="Список пуст"
  display="chip">
</p-multiSelect>
